import { connect } from "react-redux";
import { fetchFormValues, createProgram, fetchList, fetchInfo, patchProgram, updateOrder, fetchMorePrograms, resetPrograms } from "../store/actions/programs";
import { fetchMoreWorkouts, resetWorkouts } from "../store/actions/workouts";
import Form from '../components/programs/Form';
import List from '../components/programs/List';
import Info from '../components/programs/Info';
import Preview from '../components/programs/Preview';
import withAuth from '../hocs/withAuth';


function mapStateToProps(state, ownProps) {
  var editId = null;
  if (ownProps.match) editId = ownProps.match.params.id;
  if (ownProps.editId) editId = ownProps.editId;
  if (ownProps.programId) editId = ownProps.programId;
  return {
    user: state.currentUser.user,
    workouts: state.workouts.data,
    isLoadMore: state.workouts.isLoadMore,
    products: state.products,
    cats: state.programCats,
    workoutCats: state.workoutCats,
    programs: state.programs.data,
    programInfo: state.programs.info,
    programWorkouts: state.programs.workouts,
    isLoadMoreListing: state.programs.isLoadMore,
    editId: editId
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchInfo: (programId) => {
      return dispatch(fetchInfo(programId));
    },
    fetch: (userId, editId) => {
      return dispatch(fetchFormValues(userId, editId));
    },
    fetchMoreWorkouts: (query) => {
			return dispatch(fetchMoreWorkouts(query));
		},
    updateOrder: (items) => {
			return dispatch(updateOrder(items));
		},
    resetWorkouts: (query) => {
      return dispatch(resetWorkouts(query));
    },
    fetchListData: (query) => {
			return dispatch(fetchList(query));
		},
    fetchMorePrograms: (query) => {
			return dispatch(fetchMorePrograms(query));
		},
    resetPrograms: (query) => {
      return dispatch(resetPrograms(query));
    },
    create: (parentData, weeks) => {
      let userType = ownProps.user.type;
      if (userType && userType.includes('trainer')) {
        userType = 'trainer';
      }
      if (userType && userType.includes('brand')) {
        userType = 'brand';
      }
      if (userType && userType.includes('corporate')) {
        userType = 'corporate';
      }
      return dispatch(createProgram(
        {
          ...parentData,
          creatorId: ownProps.user._id,
          creatorType: userType
        },
        weeks));
    },
    edit: (parentData, weeks, deletedWeek) => {
      return dispatch(patchProgram(parentData, weeks, deletedWeek));
    }
  }
}

export const CreateProgram = withAuth(connect(mapStateToProps, mapDispatchToProps)(Form));
export const EditProgram = withAuth(connect(mapStateToProps, mapDispatchToProps)(Form));
export const ProgramLibrary = withAuth(connect(mapStateToProps, mapDispatchToProps)(List));
export const ProgramInfo = withAuth(connect(mapStateToProps, mapDispatchToProps)(Info));
export const PreviewProgramInfo = withAuth(connect(mapStateToProps, mapDispatchToProps)(Preview));




// WEBPACK FOOTER //
// ./src/containers/Programs.js